module.exports = __webpack_public_path__ + "assets/images/vacina.1935978a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kits/vacina.png
// module id = 818
// module chunks = 1